// src/catalog/components/detail/CatalogEntryContactPanel.jsx

export default function CatalogEntryContactPanel({ contactEmail }) {
  if (!contactEmail) {
    return null;
  }

  return (
    <div className="catalog-detail__panel">
      <h2>Contact</h2>

      <p>
        <a href={`mailto:${contactEmail}`}>
          {contactEmail}
        </a>
      </p>
    </div>
  );
}
